const PRODUCTION = 'production';
const STAGING = 'staging';

const LOCAL = 'local';
const REMOTE = 'remote';

window.ENVIRONMENT = PRODUCTION; // PRODUCTION
window.SERVER = REMOTE; // REMOTE

export const serviceTracker_allowed = true;

// Firebase production
const fbConfigProduction = {
  apiKey: 'AIzaSyDBUK-UdmeUqOIe31H_NEW7EdFSlwKGEOc',
  authDomain: 'trackerapps-production.firebaseapp.com',
  databaseURL: 'https://trackerapps-production.firebaseio.com',
  projectId: 'trackerapps-production',
  storageBucket: 'trackerapps-production.appspot.com',
  messagingSenderId: '785688094385'
};

//Firebase staging
const fbConfigStaging = {
  apiKey: 'AIzaSyBtAPX8CSOdw3vM4MHTdhC1O2kv2kiRtmA',
  authDomain: 'servicetracker-staging.firebaseapp.com',
  databaseURL: 'https://servicetracker-staging.firebaseio.com',
  projectId: 'servicetracker-staging',
  storageBucket: 'servicetracker-staging.appspot.com',
  messagingSenderId: '89140246824'
};

const fbFunctionsURLProduction =
  'https://us-central1-trackerapps-production.cloudfunctions.net';
const fbFunctionsURLStaging =
  'https://us-central1-servicetracker-staging.cloudfunctions.net';

const fbFunctionsURLLocalProduction =
  'http://localhost:5000/trackerapps-production/us-central1';
const fbFunctionsURLLocalStaging =
  'http://localhost:5000/servicetracker-staging/us-central1';

export const fbConfig =
  window.ENVIRONMENT === PRODUCTION ? fbConfigProduction : fbConfigStaging;
export const fbFunctionsURL =
  window.SERVER === LOCAL
    ? window.ENVIRONMENT === PRODUCTION
      ? fbFunctionsURLLocalProduction
      : fbFunctionsURLLocalStaging
    : window.ENVIRONMENT === PRODUCTION
    ? fbFunctionsURLProduction
    : fbFunctionsURLStaging;

export const environment = window.ENVIRONMENT;



// WEBPACK FOOTER //
// ./src/config.js